// 蘑菇项目用户状态管理
export const useMoguUser = () => {
  const isLoggedIn = () => {
    const token = localStorage.getItem('mogu_access_token')
    const expires = localStorage.getItem('mogu_token_expires')
    if (!token || !expires) return false
    
    // 检查Token是否过期
    if (Date.now() > parseInt(expires)) {
      // Token过期，清除
      localStorage.removeItem('mogu_access_token')
      localStorage.removeItem('mogu_token_expires')
      localStorage.removeItem('mogu_user_info')
      return false
    }
    
    return true
  }
  
  const getUserInfo = () => {
    const userInfoStr = localStorage.getItem('mogu_user_info')
    if (!userInfoStr) return null
    
    try {
      return JSON.parse(userInfoStr)
    } catch (error) {
      console.warn('解析用户信息失败:', error)
      return null
    }
  }
  
  const getToken = () => {
    return localStorage.getItem('mogu_access_token')
  }
  
  const setToken = (token) => {
    localStorage.setItem('mogu_access_token', token)
    localStorage.setItem('mogu_token_expires', (Date.now() + 24 * 60 * 60 * 1000).toString())
  }
  
  const setUserInfo = (userInfo) => {
    localStorage.setItem('mogu_user_info', JSON.stringify(userInfo))
  }
  
  const updateUserInfo = async (token) => {
    try {
      const { authVerify } = await import('@/api/user')
      const response = await authVerify(token)
      
      if (response.code === 'success' && response.data) {
        localStorage.setItem('mogu_user_info', JSON.stringify(response.data))
        return response.data
      }
      return null
    } catch (error) {
      console.error('更新用户信息失败:', error)
      return null
    }
  }
  
  const logout = () => {
    localStorage.removeItem('mogu_access_token')
    localStorage.removeItem('mogu_token_expires')
    localStorage.removeItem('mogu_user_info')
  }
  
  return {
    isLoggedIn,
    getUserInfo,
    getToken,
    setToken,
    setUserInfo,
    updateUserInfo,
    logout
  }
}

// 统一认证中心登录处理
export const handleAuthCenterLogin = () => {
  // 构建认证中心URL
  const authCenterUrl = process.env.VUE_APP_AUTH_CENTER_URL
  const clientId = process.env.VUE_APP_CLIENT_ID
  const redirectUri = `${window.location.origin}/#/auth/callback`
  const fromPage = window.location.href
  
  console.log('构建认证中心URL参数:', {
    authCenterUrl,
    clientId,
    redirectUri,
    fromPage
  })
  
  // 构建客户端信息（不包含timestamp）
  const clientInfo = {
    clientId: clientId,
    redirectUri: redirectUri
  }
  
  // 构建state参数：来源页面|客户端信息
  const state = fromPage + '|' + JSON.stringify(clientInfo)
  
  // 跳转到认证中心，只使用state参数
  const loginUrl = `${authCenterUrl}/#/login?state=${state}`
  
  console.log('跳转到认证中心:', loginUrl)
  console.log('State参数内容:', state)
  window.location.href = loginUrl
}



// WEBPACK FOOTER //
// ./src/utils/authUtils.js